import React from 'react';

import { Navigate } from 'react-router-dom';

import { RoutePath } from '@/types';

import { IAuthGuard } from './AuthGuard.types';
import { useAuthGuard } from './useAuthGuard';

const AuthGuard = (props: IAuthGuard) => {
	const { children, id } = props;
	const { shouldAccessRoute } = useAuthGuard();

	return (
		<>
			{shouldAccessRoute(id) ? (
				children
			) : (
				<Navigate to={RoutePath.DASHBOARD} replace />
			)}
		</>
	);
};

export default AuthGuard;
